import * as Sentry from '@sentry/react';
import { fullStoryIntegration } from '@sentry/fullstory';
import { Logger } from '../logger';
var SentryService = /** @class */ (function () {
    function SentryService() {
    }
    SentryService.isInitialized = function () {
        return this.initialized;
    };
    SentryService.init = function (sentryConfig) {
        var isRightEnvironment = ['qa', 'staging', 'production'].includes(sentryConfig.environment);
        var isConfigured = sentryConfig.sentrySlug && sentryConfig.sentryDsn;
        if (!isRightEnvironment || !isConfigured) {
            return;
        }
        var integrations = [];
        if (sentryConfig.fsApi) {
            var integration = fullStoryIntegration(sentryConfig.sentrySlug, {
                client: sentryConfig.fsApi,
            });
            integrations.push(integration);
        }
        Sentry.init({
            integrations: integrations,
            dsn: sentryConfig.sentryDsn,
            environment: sentryConfig.environment,
            beforeSend: function (event, eventHint) {
                var _a;
                var exception = ((eventHint === null || eventHint === void 0 ? void 0 : eventHint.originalException) || {});
                if (exception) {
                    if (exception.code === 'ServiceUnavailable' && exception.status === 503) {
                        return null;
                    }
                    if (exception.message && exception.message.includes('PubNub call failed')) {
                        Logger.log(exception.message);
                        return null;
                    }
                    var networkErrors = ['Load failed', 'Failed to fetch', 'network error (Error)'];
                    if (networkErrors.includes(exception.message)) {
                        return null;
                    }
                    var ignoredStatusCodes = [402, 403];
                    if (ignoredStatusCodes.includes(exception.status)) {
                        return null;
                    }
                    if (exception.code === 'PaymentRequired') {
                        return null;
                    }
                    var isLdError = false;
                    // try-catch to handle the following access error:
                    // The DOMException.name getter can only be used on instances of DOMException
                    try {
                        isLdError = ((_a = Object.getPrototypeOf(exception)) === null || _a === void 0 ? void 0 : _a.name) === 'LaunchDarklyFlagFetchError';
                    }
                    catch (e) {
                        // ignore
                    }
                    if (isLdError) {
                        return null;
                    }
                }
                return event;
            },
        });
        SentryService.initialized = true;
    };
    SentryService.captureException = function (e) {
        if (SentryService.isInitialized()) {
            if (e instanceof Error) {
                Sentry.captureException(e);
            }
            else if (e.message) {
                Sentry.withScope(function (scope) {
                    scope.setExtra('extraInfo', e);
                    Sentry.captureException(new Error(e.message));
                });
            }
            else {
                Sentry.captureException(e);
            }
        }
        else {
            console.log(e);
        }
    };
    SentryService.initialized = false;
    return SentryService;
}());
export { SentryService };
